/** @format */

import { useState, useRef } from "react";
import { sessionFileType } from "../constance/typeModel";
import { validationPattern } from "../validators/publicValidator";

const useInquiryFileHooks = (FileDatas: sessionFileType[] | null, setFileData: Function, maxsize: number) => {
  // ツールチップState
  const [tip, setTip] = useState(false);
  const FileRef = useRef<HTMLInputElement>(null);
  // ツールチップState変更関数
  const tipChangeHandler = () => {
    setTip((prev) => !prev);
  };

  const getExtension = (filename: string): string => {
    const lastDot = filename.lastIndexOf(".");
    if (lastDot === -1 || lastDot === filename.length - 1) return "";
    return filename.slice(lastDot + 1).toLowerCase();
  };

  const normalizeExtensions = (exts: string[]) => exts.map((x) => x.trim().toLowerCase().replace(/^\./, ""));

  const normalizeMime = (mime: string) => (mime ?? "").trim().toLowerCase();

  type ValidateResult = { ok: boolean; reason?: "ext" | "mime" };

  const validateFileExtAndMime = (file: File, allowedExts: string[], allowedMimes: string[]): ValidateResult => {
    const ext = getExtension(file.name);
    const mime = normalizeMime(file.type);

    const exts = normalizeExtensions(allowedExts);
    const mimes = allowedMimes.map((x) => x.toLowerCase());

    // 拡張子は必須
    if (!ext || !exts.includes(ext)) return { ok: false, reason: "ext" };

    // MIMEが取れない環境はあるので、その場合は拡張子OKなら通す
    if (!mime) return { ok: true };

    if (!mimes.includes(mime)) return { ok: false, reason: "mime" };

    return { ok: true };
  };

  // ファイルの登録
  const loadFile = (e: { target: { value: string | null } }) => {
    const inputFiles = FileRef.current !== null ? FileRef.current.files : null;
    if (inputFiles === null) return;

    const target = e.target;
    const fileArray: sessionFileType[] = FileDatas !== null ? [...FileDatas] : [];

    const maxSizeByte = 1024 * 1024 * maxsize;
    const totalSize = [...inputFiles].reduce(
      (sum, file) => sum + file.size,
      fileArray.reduce((sum, file) => sum + file.file_size, 0),
    );
    if (totalSize > maxSizeByte) {
      return alert(`ファイルの登録に失敗しました。アップロードできるファイルの合計サイズは最大${maxsize}MBまでです。`);
    }

    // ファイル読み込み処理
    for (let file of inputFiles) {
      const result = validateFileExtAndMime(file, validationPattern.file, validationPattern.fileMimeType);
      if (!result.ok) {
        return alert("png, jpg, jpeg, pdf以外は登録できません。");
      }

      let fr = new FileReader();
      fr.onload = () => {
        const insertFileData = fr.result !== null && typeof fr.result === "string" ? fr.result.split(",")[1] : "";
        const tempFileData = {
          file_name_origin: file.name,
          file_data: insertFileData,
          file_size: file.size,
        };
        fileArray.push(tempFileData);
        setFileData([...fileArray]);
      };
      fr.readAsDataURL(file);
    }

    // 同じファイルを再登録できるようにする
    setTimeout(() => {
      target.value = null;
    }, 1000);
  };

  // アップロードしたファイルの削除
  const deleteFile = (num: number) => {
    if (FileDatas === null) return;
    const newFileArray = FileDatas.filter((file: sessionFileType, index: number) => index !== num);
    setFileData(newFileArray);
  };

  return {
    tip,
    tipChangeHandler,
    FileRef,
    loadFile,
    deleteFile,
  };
};

export default useInquiryFileHooks;
